<template>
  <universal-search app-shareable save-filters-to-url />
</template>

<script>
import UniversalSearch from '@/components/UniversalSearch/UniversalSearch.vue';

export default {
  name: 'index',
  components: {
    UniversalSearch,
  },
  // Remove local scroll position management since it's now handled by the router
};
</script>
